export default "__VITE_ASSET__BMc3xGra__"